import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Hero() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    organization: '',
    chapter: '',
    school: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleContinue = (e) => {
    e.preventDefault();
    // For now, just navigate to /register
    // In the future, you can pass the form data via state
    navigate('/register', { state: formData });
  };

  return (
    <section style={{ backgroundColor: '#F8F9FB' }} className="py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Value Proposition */}
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
              Manage Your Chapter's Academics. Simply.
            </h1>
            <p className="mt-4 text-lg text-gray-600">
              The all-in-one app for fraternities and sororities to track study points,
              manage member progress, and foster academic accountability.
            </p>

            {/* Install Links */}
            <div className="mt-8 flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <a
                href="https://apps.apple.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition"
              >
                <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                </svg>
                Download on the App Store
              </a>
            </div>
          </div>

          {/* Right Column - Registration Form */}
          <div className="bg-white p-8 rounded-lg shadow-xl">
            <h2 className="text-2xl font-semibold mb-6 text-gray-900">
              Register Your Organization
            </h2>
            <form onSubmit={handleContinue}>
              {/* Greek Organization */}
              <div className="mb-4">
                <label
                  htmlFor="organization"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Greek Organization
                </label>
                <input
                  type="text"
                  id="organization"
                  name="organization"
                  value={formData.organization}
                  onChange={handleInputChange}
                  placeholder="e.g., Theta Chi"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:border-transparent"
                  style={{ '--tw-ring-color': '#007bff' }}
                  onFocus={(e) => e.target.style.boxShadow = '0 0 0 2px #007bff'}
                  onBlur={(e) => e.target.style.boxShadow = ''}
                  required
                />
              </div>

              {/* Greek Chapter */}
              <div className="mb-4">
                <label
                  htmlFor="chapter"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Greek Chapter
                </label>
                <input
                  type="text"
                  id="chapter"
                  name="chapter"
                  value={formData.chapter}
                  onChange={handleInputChange}
                  placeholder="e.g., Alpha Omicron"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:border-transparent"
                  onFocus={(e) => e.target.style.boxShadow = '0 0 0 2px #007bff'}
                  onBlur={(e) => e.target.style.boxShadow = ''}
                  required
                />
              </div>

              {/* School Name */}
              <div className="mb-6">
                <label
                  htmlFor="school"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  School Name
                </label>
                <input
                  type="text"
                  id="school"
                  name="school"
                  value={formData.school}
                  onChange={handleInputChange}
                  placeholder="e.g., University of North Texas"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:border-transparent"
                  onFocus={(e) => e.target.style.boxShadow = '0 0 0 2px #007bff'}
                  onBlur={(e) => e.target.style.boxShadow = ''}
                  required
                />
              </div>

              {/* CTA Button */}
              <button
                type="submit"
                className="w-full py-3 px-4 text-white rounded-md font-semibold transition"
                style={{ backgroundColor: '#a60533' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#8a0429'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#a60533'}
              >
                Continue
              </button>

              {/* Login Link */}
              <p className="text-center mt-4 text-sm text-gray-500">
                Already have an account?{' '}
                <Link to="/login" className="font-medium" style={{ color: '#a60533' }} onMouseEnter={(e) => e.target.style.color = '#8a0429'} onMouseLeave={(e) => e.target.style.color = '#a60533'}>
                  Log In
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;

